import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import _ from 'lodash';
import {
  Grid,
  Chip,
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from '@mui/material';
import { AutocompleteV, SimpleDialog, Icons } from 'components';
import { enifyDateTime } from 'utility';
import Services from './services/Services';
import { useStyles } from './style';

const Dealers = (props) => {
  // --PROPS--//
  const {
    methods,
    singleSelect = false,
    selected = [],
    setSelected = () => { },
    className,
    style,
    children,
    placeholder = 'جستجو و انتخاب کنید...',
    label = 'کارگزارها',
    name = 'dealers',
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);
  const [isFullListModalOpen, setIsFullListModalOpen] = useState(false);
  const [dealersSearchText, setDealersSearchText] = useState('');
  const [dealersList, setDealersList] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    const numberTester = new RegExp(/^[0-9]+$/);

    const getDealers = async (searchValue) => {
      setLoading(true);
      setDealersList([]);

      try {
        const q = {
          query: null,
          id: null,
          size: 100_000_000, // FIXME: It's not true to set size here
          offset: 0,
        };

        const val = enifyDateTime(searchValue);

        q[numberTester.test(val) ? 'id' : 'query'] = null;

        const result = await Services.getDealers(q);
        const data = result.result;
        let list = [];
        list = data.map((v) => ({
          name: v?.dealer?.name,
          id: v?.dealer?.id,
          label: `${v?.dealer?.name} (شناسه: ${v?.dealer?.id})`,
          value: v?.dealer?.id,
        }));
        setDealersList(list);
      } catch (e) { }
      setLoading(false);
    };

    getDealers();
  }, []);

  // -- OTHER FUNCTIONS --//
  const handleDeselectItem = (id, arr, setter) => {
    const temp = [...arr];
    _.remove(temp, function (v) {
      return v?.id === id;
    });
    setter([...temp]);
  };

  const showFullModal = () => {
    setIsFullListModalOpen(true);
  };

  const getCurrentFullList = () => {
    return singleSelect ? selected : [...selected];
  };

  const getCurrentFullListSetter = () => {
    return setSelected;
  };

  const hideFullModal = () => {
    setIsFullListModalOpen(false);
  };

  return (
    <Grid item xs={12}>
      <Grid item xs={12} className={clsx(classes.root, className)} style={style}>
        <AutocompleteV
          control={methods?.control}
          errors={methods?.errors}
          register={methods?.register}
          placeholder={placeholder}
          name={name}
          label={label}
          list={dealersList}
          loading={loading}
          inputValue={singleSelect ? undefined : dealersSearchText}
          getOptionSelected={(option, value) => option.id === value.id}
          getOptionDisabled={(option) =>
            singleSelect ? selected : selected?.find((v) => v?.id === option?.id) != null
          }
          onInputChange={(e) => {
            setDealersSearchText(e?.target?.value ?? '');
          }}
          onChangeValue={(p) => {
            setDealersSearchText('');
            if (!p) return;
            if (singleSelect) {
              setSelected(p);
            } else {
              const temp = [...selected];
              temp.push(p);
              setSelected([...temp]);
            }
            if (methods?.setValue) {
              methods?.setValue(name, p);
            }
          }}
          preventAddCustomOption
          clearOn={!singleSelect}
          disableClearable={!singleSelect}
          {...rest}
        />

        {!singleSelect ? (
          <div style={{ marginTop: 0 }}>
            {selected.map((v, k) =>
              k > 4 ? null : (
                <Chip
                  className={classes.chip}
                  key={k}
                  label={<Typography style={{ fontSize: 12 }}>{`${v?.id}. ${v?.name}`}</Typography>}
                  onClick={() => { }}
                  onDelete={() => handleDeselectItem(v?.id, selected, setSelected)}
                />
              ),
            )}
            {selected.length > 4 ? (
              <Chip
                className={classes.chipOutline}
                label={<Typography style={{ fontSize: 12 }}>نمایش بیشتر...</Typography>}
                onClick={() => showFullModal()}
              />
            ) : null}
          </div>
        ) : null}
      </Grid>

      {/* Selected Items List */}
      {!singleSelect ? (
        <SimpleDialog
          title="لیست حساب‌های انتخاب شده"
          open={isFullListModalOpen}
          onClose={() => hideFullModal()}
        >
          <TableContainer elevation={0} component={Paper} className={classes.table}>
            <Table>
              <TableHead className={classes.tableHeader}>
                <TableRow>
                  <TableCell className={classes.tableCell} style={{ width: '10%' }}>
                    شناسه
                  </TableCell>
                  <TableCell className={classes.tableCell}>عنوان</TableCell>
                  <TableCell className={classes.tableCell} />
                </TableRow>
              </TableHead>
              <TableBody>
                {/* List Data Map */}
                {getCurrentFullList().map((v, k) => (
                  <TableRow key={k}>
                    <TableCell className={classes.tableDataCell}>{v?.id}</TableCell>
                    <TableCell className={classes.tableDataCell}>{v?.label}</TableCell>
                    <TableCell align="right" className={classes.tableDataCell}>
                      <IconButton
                        className={classes.actionsIcon}
                        onClick={() => {
                          handleDeselectItem(
                            v?.id,
                            getCurrentFullList(),
                            getCurrentFullListSetter(),
                          );
                        }}
                        size="large">
                        <Icons icon="Trash" color="#2b3990" size="20" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SimpleDialog>
      ) : null}
      {/* End Selected Items List */}
    </Grid>
  );
};

export default Dealers;
